<template>
  <div class="media-page">
    <div class="container">
      <NavigationBar/>
    </div>

    <div class="container">
      <div class="media-header">
        <h1>{{ $t('media-page-title') }}</h1>
        <p>{{ $t('media-page-subtitle') }}</p>
      </div>

      <a
          :href="featured.url"
          target="_blank"
          rel="noopener noreferrer"
          class="media-featured"
      >
        <div class="media-featured__image">
          <img :src="featured.image" :alt="featured.title"/>
        </div>
        <div class="media-featured__content">
          <span class="media-source">{{ featured.source }}</span>
          <h2>{{ featured.title }}</h2>
          <span class="media-cta">{{ $t('read-more') }} &rarr;</span>
        </div>
      </a>

      <div class="media-grid">
        <a
            v-for="(item, index) in restItems"
            :key="index"
            :href="item.url"
            target="_blank"
            rel="noopener noreferrer"
            class="media-card"
        >
          <div
              class="media-card__image"
              :class="{ 'media-card__image--placeholder': !item.image }"
              :style="item.image ? { backgroundImage: 'url(' + item.image + ')' } : {}"
          >
            <span v-if="!item.image" class="media-card__image-fallback">{{ item.source }}</span>
          </div>
          <div class="media-card__body">
            <span class="media-source">{{ item.source }}</span>
            <h3>{{ item.title }}</h3>
          </div>
        </a>
      </div>
    </div>
  </div>

  <FooterComponent/>
</template>

<script setup>
import { computed } from 'vue';
import NavigationBar from '@/components/NavigationBar.vue';
import FooterComponent from '@/components/Components/FooterComponent.vue';

// Same set of press mentions as NewsCarousel.vue, enriched with a display source name.
const mediaItems = [
  {
    title: '"Не си сама": Женя, която превърна AI в подкрепа за майките',
    source: 'Business Novinite',
    image: '/static/news/presentation.jpg',
    url: 'https://businessnovinite.bg/esg/ne-si-sama-zhenja-kojato-prevarna-ai-v-podkrepa-za-majkite.html',
  },
  {
    title: 'Проучване разкрива тревожни данни за психичното здраве на майките у нас',
    source: 'Nova - Пресечна точка',
    image: '/static/news/nova-presechna-tochka.jpg',
    url: 'https://nova.bg/news/view/2026/03/19/530909/%D0%BF%D1%80%D0%BE%D1%83%D1%87%D0%B2%D0%B0%D0%BD%D0%B5-%D1%80%D0%B0%D0%B7%D0%BA%D1%80%D0%B8%D0%B2%D0%B0-%D1%82%D1%80%D0%B5%D0%B2%D0%BE%D0%B6%D0%BD%D0%B8-%D0%B4%D0%B0%D0%BD%D0%BD%D0%B8-%D0%B7%D0%B0-%D0%BF%D1%81%D0%B8%D1%85%D0%B8%D1%87%D0%BD%D0%BE%D1%82%D0%BE-%D0%B7%D0%B4%D1%80%D0%B0%D0%B2%D0%B5-%D0%BD%D0%B0-%D0%BC%D0%B0%D0%B9%D0%BA%D0%B8%D1%82%D0%B5-%D1%83-%D0%BD%D0%B0%D1%81/',
  },
  {
    title: 'Проучване показва, че 42% от младите майки мислят, че не се справят като родители',
    source: 'Nova - На кафе',
    image: 'https://nbg-img.fite.tv/img/658877_1200x675.jpg',
    url: 'https://play.nova.bg/video/na-kafe/season-17/kafe-2026-03-13-1/658877',
  },
  {
    title: 'Momfident - мобилно приложение за 24/7 психологическа превантивна грижа за майки',
    source: '9 месеца',
    image: 'https://i.ytimg.com/vi/FJ_VQO8iI4Y/hqdefault.jpg',
    url: 'https://www.youtube.com/watch?v=FJ_VQO8iI4Y',
  },
  {
    title: 'Майчинството и невидимият натиск',
    source: 'БНР Христо Ботев',
    image: 'https://bnrnews.bg/api/media/2f4c79c4-435f-4701-873c-0aa3f14e8950?Size=large',
    url: 'https://bnrnews.bg/hristobotev/post/441571/maychinstvoto-i-nevidimiyat-natisk',
  },
  {
    title: 'Проучване разкрива трудния път на българското майчинство според жените',
    source: 'Mamamia.bg',
    image: 'https://static.webcafe.bg/uploads/images/47/2947/392947/768x.jpg?_=1773243166',
    url: 'https://mamamia.bg/maternity/prouchvane-razkriva-trudniya-pat-na-balgarskoto-maychinstvo-spored-zhenite.html',
  },
  {
    title: '44% от майките не желаят повече деца, защото им е трудно като майки',
    source: 'Жената днес',
    image: 'https://www.jenatadnes.com/wp-content/uploads/2026/03/Momfident-079-scaled.jpg',
    url: 'https://www.jenatadnes.com/kakvo-novo/44-ot-maikite-ne-jelayat-poveche-detsa-zashtoto-im-e-trudno-kato-maiki/',
  },
  {
    title: 'Форум „Данни, които рядко чуваме“ за психичното здраве на майките в България',
    source: 'Новите родители',
    image: '/static/news/Momfident 059.jpg',
    url: 'https://www.noviteroditeli.bg/novini/forum-danni-koito-ryadko-chuvame-za-psihichnoto-zdrave-na-maykite-v-blgariya',
  },
  {
    title: 'Стрес, умора, вина: Почти половината от младите майки у нас не искат второ дете',
    source: 'Actualno',
    image: 'https://cdn.actualno.eu/actualno_2013/upload/news/2026/03/12/073bf7d4a322316d022491606c02e743_2567134_1920x1080.jpg',
    url: 'https://www.actualno.com/society/stres-umora-vina-pochti-polovinata-ot-mladite-majki-u-nas-ne-iskat-vtoro-dete-news_2567134.html',
  },
  {
    title: '42% от българките смятат себе си за лоши майки',
    source: 'Offnews',
    image: 'https://i2.offnews.bg/events/2026/03/12/862801/phpmr0kqh_800x*.jpg',
    url: 'https://offnews.bg/zdrave/42-ot-balgarkite-smiatat-sebe-si-za-loshi-majki-23-ot-tiah-sa-i-862801.html',
  },
  {
    title: 'AI приложение за майки: Над 50% от младите майки не получават нужната подкрепа',
    source: 'БНТ',
    image: '/static/news/presentation2.png',
    url: 'https://bnt.bg/news/ai-prilozhenie-za-maiki-nad-50-ot-mladite-maiki-ne-poluchavat-nuzhnata-podkrepa-v400582-343068news.html',
  },
  {
    title: 'Следродилната депресия: жени помагат на жени',
    source: 'bTV',
    image: 'https://cdn.btv.bg/media/images/640x360/Jul2025/2113598699.jpg',
    url: 'https://www.btv.bg/shows/predi-obed/videos/sledrodilnata-depresija-zheni-pomagat-na-zheni.html',
  },
  {
    title: 'Ново приложение ще помага на жени със следродилна депресия',
    source: 'БНТ',
    image: 'https://bnt.bg/f/media_video/b/393/2d0b97cd5527e8aff11a7bf3310305a0.png',
    url: 'https://bnt.bg/news/novo-prilozhenie-shte-pomaga-na-zheni-sas-sledrodilna-depresiya-v393986-340426news.html',
  },
  {
    title: 'Проучване разкрива какви са проблемите на съвременните млади майки',
    source: 'BG ON AIR',
    image: 'https://bgonair.bg/files/download/22412',
    url: 'https://www.bgonair.bg/a/36-sutreshen-blok/385064-prouchvane-razkriva-kakvi-sa-problemite-na-savremennite-mladi-mayki',
  },
  {
    title: 'Вина, самота, несигурност: картината на следродилната депресия в България',
    source: 'Actualno',
    image: 'https://i.actualno.com/actualno_2013/upload/2025/06/17/0755524001750160034_big.webp',
    url: 'https://www.actualno.com/interview/vina-samota-nesigurnost-kartinata-na-sledrodilnata-depresija-v-bylgarija-video-news_2460343.html',
  },
  {
    title: 'Ново приложение в помощ на младите майки',
    source: 'БНР',
    image: 'https://static.bnr.bg/gallery/cr/medium/e60f1a8d8d5fcd3b6847e7d65e33e4cf.jpg',
    url: 'https://bnr.bg/sofia/post/102171185/novo-prilojenie-v-pomosht-na-mladite-maiki',
  },
  {
    title: 'Д-р Стоянка Черкезова от БАН за следродилната депресия',
    source: 'btv Radio',
    image: 'https://cdn.btv.bg/media/images/940x530/Apr2015/2110398214.webp',
    url: 'https://btvradio.bg/intervuta/za-grada/doc-stojanka-cherkezova-ot-ban.html',
  },
  {
    title: 'За сблъсъка със следродилната депресия от първо лице',
    source: 'BG ON AIR',
    image: '/static/news/zh1.png',
    url: 'https://www.bgonair.bg/a/2-bulgaria/361232-za-sblasaka-sas-sledrodilnata-depresiya-ot-parvo-litse-video',
  },
  {
    title: '"Мъмфидънт": Изкуствен интелект в помощ на майките след раждане',
    source: 'БНР Христо Ботев',
    image: 'https://static.bnr.bg/gallery/cr/medium/4f61b8d6f9be0b823d5f076be5d8178c.jpg',
    url: 'https://bnr.bg/hristobotev/post/102120723/dimitrova',
  },
  {
    title: 'Femtech Founder on the Mental Health Problems Mothers Face and Investors Ignore',
    source: 'The Recursive',
    image: 'https://storage.ghost.io/c/b8/ae/b8aee878-7ddc-40ad-8f68-92a28c560560/content/images/size/w2000/format/webp/therecursive-com/wp-content/uploads/2025/03/momfident-team.png',
    url: 'https://therecursive.com/zhenya-dimitrova-momfident-femtech-mothers-mental-health-startup/',
  },
  {
    title: 'Награда за Спиноф 2024',
    source: 'IPHS',
    image: 'https://iphs.eu/wp-content/uploads/2024/07/SpinOff24_2-1024x576.jpg',
    url: 'https://iphs.eu/2024/07/03/%D0%BD%D0%B0%D0%B3%D1%80%D0%B0%D0%B4%D0%B0-%D0%B7%D0%B0-%D1%81%D0%BF%D0%B8%D0%BD%D0%BE%D1%84-2024/',
  },
  {
    title: '"Не си сама": майки разработват инструменти за взаимопомощ за следродилна депресия',
    source: 'Капитал',
    image: 'https://img.capital.bg/shimg/zx1200y675_4775830.jpg?v=1747303793',
    url: 'https://www.capital.bg/politika_i_ikonomika/zdraveopazvane/2025/04/29/4775829_ne_si_sama_maiki_razrabotvat_instrumenti_za/',
  },
  {
    title: 'Български стартъп променя нагласите на хората за психичното здраве',
    source: 'Economic.bg',
    image: 'https://www.economic.bg/web/files/articles/146583/narrow_image/thumb_1040x585_img-5689.JPG',
    url: 'https://www.economic.bg/bg/a/view/bylgarski-startyp-promenja-naglasite-na-horata-za-psihicheskoto-zdrave',
  },
  
];

const featured = mediaItems[0];
const restItems = computed(() => mediaItems.slice(1));
</script>

<style lang="scss" scoped>
.media-page {
  padding-bottom: 60px;
  display: flow-root;
  background:
    radial-gradient(80% 60% at 80% 0%, #FFE4EA 0%, transparent 60%),
    radial-gradient(70% 60% at 10% 30%, #FBE9EC 0%, transparent 55%),
    linear-gradient(180deg, #FFF5F7 0%, #FEF5F5 60%, #FBE9EC 100%);
}

.media-header {
  text-align: center;
  margin: 20px 0 40px 0;

  h1 {
    font-size: 32px;
    font-weight: 700;
    color: $color-purple;
    font-family: $font-bold;
    margin-bottom: 12px;
  }

  p {
    font-size: 16px;
    color: #555;
  }
}

.media-source {
  display: inline-block;
  font-family: $font-semi-bold;
  font-size: 12px;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: $color-pink-dark;
  margin-bottom: 8px;
}

.media-featured {
  display: grid;
  grid-template-columns: 1.15fr 1fr;
  align-items: stretch;
  gap: 0;
  background-color: #fff;
  border-radius: 24px;
  overflow: hidden;
  text-decoration: none;
  margin-bottom: 28px;
  box-shadow: 0 20px 45px -25px rgba(107, 107, 156, 0.25);
  transition: box-shadow 0.3s ease, transform 0.3s ease;

  &:hover {
    box-shadow: 0 20px 45px -15px rgba(107, 107, 156, 0.25);
    transform: translateY(-2px);
  }

  &__image {
    min-height: 460px;
    background: linear-gradient(160deg, #FFE4EA, #FBE9EC 60%, #F7D4DD);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  &__content {
    padding: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    h2 {
      font-family: $font-semi-bold;
      font-size: 26px;
      color: $color-purple;
      line-height: 1.3;
      margin-bottom: 20px;
    }
  }
}

.media-cta {
  font-family: $font-semi-bold;
  font-size: 14px;
  color: $color-pink-dark;
}

.media-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}

.media-card {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 16px;
  overflow: hidden;
  text-decoration: none;
  box-shadow: 0 12px 30px -20px rgba(107, 107, 156, 0.3);
  transition: box-shadow 0.3s ease, transform 0.3s ease;

  &:hover {
    box-shadow: 0 15px 30px -12px rgba(107, 107, 156, 0.25);
    transform: translateY(-2px);
  }

  &__image {
    position: relative;
    padding-top: 56%;
    background-size: cover;
    background-position: center;

    &--placeholder {
      background: linear-gradient(160deg, #FFE4EA, #FBE9EC 60%, #F7D4DD);
    }
  }

  &__image-fallback {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-family: $font-semi-bold;
    font-size: 14px;
    color: $color-pink-dark;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    text-align: center;
    padding: 0 12px;
  }

  &__body {
    padding: 20px;

    h3 {
      font-family: $font-semi-bold;
      font-size: 16px;
      color: $color-purple;
      line-height: 1.35;
      margin: 0;
    }
  }
}

@media (max-width: 768px) {
  .media-header {
    margin: 12px 0 24px 0;

    h1 {
      font-size: 24px;
    }

    p {
      font-size: 14px;
    }
  }

  .media-featured {
    grid-template-columns: 1fr;

    &__image {
      min-height: 240px;
      padding: 12px;
    }

    &__content {
      padding: 20px;

      h2 {
        font-size: 18px;
      }
    }
  }

  .media-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}
</style>
